var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items && _vm.items.length)?_c('div',{class:[
    `usp`,
    {
      has_title: this.title,
      'usp--slim': this.isSlimUsp,
    },
  ],style:(_vm.cssColors),attrs:{"id":"usp","data-testid":"sbx-pcc_usp"}},[(_vm.title)?_c('div',{class:[`usp__uspTitle`, `align-${this.align}`],attrs:{"data-testid":"sbx-pcc_uspTitle"}},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('div',{class:[
      `usp__list`,
      { scrollable: this.mobileScroll == 'true' && _vm.isMobile },
      { stack: this.mobileScroll == 'false' && _vm.isMobile },
      `${this.oddGrid}`,
    ],attrs:{"data-testid":"sbx-pcc_usp_list"}},_vm._l((this.items),function(item,index){return _c('div',{key:`usp__item-${index}`,staticClass:"usp__item"},[_c('div',{class:[`usp__itemIcon`, `${_vm.getAlignClass}`]},[_c('i',{class:`si ${item.icon}`,attrs:{"data-testid":`sbx-pcc_usp-icon-${index}`}})]),_c('div',{staticClass:"usp__itemText"},[_c('div',{class:[`usp__itemTitle`, `${_vm.getAlignClass}`, { bold: item.subtitle }]},[_vm._v(_vm._s(item.title))]),(item.subtitle)?_c('div',{class:[`usp__itemSubtitle`, `${_vm.getAlignClass}`]},[_vm._v(_vm._s(item.subtitle))]):_vm._e()])])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }